import { render } from "./VInputText.vue?vue&type=template&id=36c5a595"
import script from "./VInputText.vue?vue&type=script&lang=js"
export * from "./VInputText.vue?vue&type=script&lang=js"

import exportComponent from "F:\\.openserver\\OpenServer\\domains\\geo_exams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__